import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_IS_WEB_ONLY = 'UPDATE_QR_CODE_LINK_IS_WEB_ONLY' as const;

export const updateQrCodeLinkIsWebOnly = (isWebOnly: boolean) => ({
  data: { isWebOnly },
  type: UPDATE_QR_CODE_LINK_IS_WEB_ONLY,
});

export type UpdateQrCodeLinkIsWebOnlyResponseAction = DataAction<
  typeof UPDATE_QR_CODE_LINK_IS_WEB_ONLY,
  { isWebOnly: boolean }
>;
